import { useTranslation } from 'hooks';
import cls from './tech-rules-assessment.module.scss';
import { ICONS } from 'shared/constants/images';

export const TechRulesAssesment: React.FC<{
  ruleKey: string;
  isTrial: boolean;
}> = ({ ruleKey, isTrial }) => {
  const { t, currentLocale } = useTranslation();
  const isEN = currentLocale === 'en';
  if (ruleKey === 'llm_implementation') {
    return isTrial ? (
      <div className={cls.stepsWrapper}>
        <div>
          <h4>
            {t('step')} 1 {t('llm_implementationStep1')}
          </h4>
          <p>{t('llm_implementationStep1Description')}</p>
          <div className={cls.codeblock}>
            {isEN ? (
              <>
                <code>
                  # Your Company Name
                  <br />
                  <br />
                  {'>'}Brief description of what your business does and your
                  core offerings.
                </code>
              </>
            ) : (
              <>
                <code>
                  #Dein Firmenname
                  <br />
                  <br />
                  {'>'}Kurze Beschreibung dessen, was dein Unternehmen tut und
                  deiner Kernangebote.
                </code>
              </>
            )}
          </div>
        </div>
        <div className={cls.trialOverlay}></div>
      </div>
    ) : (
      <div className={cls.stepsWrapper}>
        <div>
          <h4>
            {t('step')} 1 {t('llm_implementationStep1')}
          </h4>
          <p>{t('llm_implementationStep1Description')}</p>
          <div className={cls.codeblock}>
            {isEN ? (
              <>
                <code>
                  # Your Company Name
                  <br />
                  <br />
                  {'>'}Brief description of what your business does and your
                  core offerings.
                </code>
              </>
            ) : (
              <>
                <code>
                  # Ihr Firmenname
                  <br />
                  <br />
                  {'>'}Kurze Beschreibung dessen, was Ihr Unternehmen tut und
                  Ihrer Kernangebote.
                </code>
              </>
            )}
          </div>
        </div>
        <div>
          <h4>
            {t('step')} 2 {t('llm_implementationStep2')}
          </h4>
          <p>{t('llm_implementationStep2Description')}</p>
          <div className={cls.codeblock}>
            {isEN ? (
              <>
                <code>
                  ## Products <br />
                  - [Product Name](https://example.com/products/product-name):
                  Brief description
                  <br />
                  - [Another Product](https://example.com/products/another):
                  Brief description
                  <br />
                  <br />
                  ## Services
                  <br />
                  - [Service Name](https://example.com/services/service-name):
                  What this service provides
                  <br />
                  <br />
                  ## About
                  <br />- [Company Info](https://example.com/about): Company
                  background and mission
                </code>
              </>
            ) : (
              <>
                <code>
                  ## Produkte
                  <br />
                  - [Produktname](https://beispiel.de/produkte/produktname):
                  Kurze Beschreibung
                  <br />
                  - [Weiteres Produkt](https://beispiel.de/produkte/weiteres):
                  Kurze Beschreibung
                  <br />
                  <br />
                  ## Dienstleistungen
                  <br />
                  -
                  [Dienstleistungsname](https://beispiel.de/dienstleistungen/name):
                  Was diese Dienstleistung bietet
                  <br />
                  <br />
                  ## Über uns
                  <br />- [Firmeninfo](https://beispiel.de/ueber-uns):
                  Firmenhintergrund und Mission
                </code>
              </>
            )}
          </div>
        </div>
        <div>
          <h4>
            {t('step')} 3 {t('llm_implementationStep3')}
          </h4>
          <p>{t('llm_implementationStep3Description')}</p>
          <div className={cls.codeblock}>
            {isEN ? (
              <>
                <code>
                  ## Crawl Directives
                  <br />
                  ### Allow
                  <br />
                  - /products/*
                  <br />
                  - /services/*
                  <br />
                  - /blog/*
                  <br />
                  <br />
                  ### Disallow
                  <br />
                  - /cart/*
                  <br />
                  - /admin/*
                  <br />
                  - /internal/*
                  <br />
                  ## Geographic Focus
                  <br />
                  <br />
                  - Primary: United States, Canada
                  <br />
                  - Secondary: United Kingdom, Germany
                  <br />
                  <br />
                  ## Target Audiences
                  <br />
                  - Small business owners (5-50 employees)
                  <br />- Marketing professionals
                </code>
              </>
            ) : (
              <>
                <code>
                  ## Crawl-Direktiven
                  <br />
                  ### Allow (Erlauben)
                  <br />
                  - /produkte/*
                  <br />
                  - /dienstleistungen/*
                  <br />
                  - /blog/*
                  <br />
                  <br />
                  ### Disallow (Verbieten)
                  <br />
                  - /warenkorb/*
                  <br />
                  - /admin/*
                  <br />
                  - /intern/*
                  <br />
                  <br />
                  ## Geografischer Fokus
                  <br />
                  - Primär: Deutschland, Österreich, Schweiz
                  <br />
                  - Sekundär: Frankreich, Niederlande
                  <br />
                  <br />
                  ## Zielgruppen
                  <br />
                  - Kleinunternehmer (5-50 Mitarbeiter)
                  <br />- Marketing-Fachleute
                </code>
              </>
            )}
          </div>
        </div>
        <div>
          <h4>
            {t('step')} 4 {t('llm_implementationStep4')}
          </h4>
          <p>{t('llm_implementationStep4Description')}</p>
          <div className={cls.codeblock}>
            {isEN ? (
              <>
                <code>
                  ## Notes
                  <br />
                  Last updated: 2025-01-13
                  <br />
                  Update frequency: Monthly
                </code>
              </>
            ) : (
              <>
                <code>
                  ## Hinweise <br />
                  Zuletzt aktualisiert: 13.01.2025
                  <br />
                  Aktualisierungshäufigkeit: Monatlich
                  <br />
                </code>
              </>
            )}
          </div>
        </div>
        <div>
          <h4>
            {t('step')} 5 {t('llm_implementationStep5')}
          </h4>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('llm_implementationStep5Bullet1')}</li>
            <li>{t('llm_implementationStep5Bullet2')}</li>
            <li>{t('llm_implementationStep5Bullet3')}</li>
            <li>{t('llm_implementationStep5Bullet4')}</li>
            <li>{t('llm_implementationStep5Bullet5')}</li>
          </ul>
        </div>
        <div>
          <h4>
            {t('bestPractices')}:{' '}
            <span>{t('llm_implementationBestPractices')}</span>
          </h4>
        </div>
      </div>
    );
  }

  if (ruleKey === 'js_crawlability') {
    return isTrial ? (
      <div className={cls.stepsWrapper}>
        <div>
          <h4>
            {t('step')} 1 {t('js_crawlabilityStep1')}
          </h4>
          <p>{t('js_crawlabilityStep1Description')}</p>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('js_crawlabilityStep1Bullet1')}</li>
            <li>{t('js_crawlabilityStep1Bullet2')}</li>
            <li>{t('js_crawlabilityStep1Bullet3')}</li>
          </ul>
          <p>{t('js_crawlabilityStep1Description2')}</p>
          <div className={cls.codeblock}>
            {
              // eslint-disable-next-line react/jsx-no-comment-textnodes
              <code>
                // app/page.js
                <br />
                export default async function Page() {'{'}
                <br />
                &nbsp;const data = await fetch('https://api.example.com/data')
                <br />
                &nbsp;const json = await data.json()
                <br />
                &nbsp;return {'<div>{json.content}</div>'}
                <br />
                {'}'}
              </code>
            }
          </div>
          <p>{t('js_crawlabilityStep1Description3')}</p>
          <div className={cls.codeblock}>
            {
              // eslint-disable-next-line react/jsx-no-comment-textnodes
              <code>
                // pages/[id].js
                <br />
                export async function getStaticProps({'{ params }'}) {'{'}
                <br />
                &nbsp;const data = await fetchData(params.id)
                <br />
                &nbsp;return {'{ props: { data } }'}
                <br />
                {'}'}
              </code>
            }
          </div>
        </div>
        <div className={cls.trialOverlay}></div>
      </div>
    ) : (
      <div className={cls.stepsWrapper}>
        <div>
          <h4>
            {t('step')} 1 {t('js_crawlabilityStep1')}
          </h4>
          <p>{t('js_crawlabilityStep1Description')}</p>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('js_crawlabilityStep1Bullet1')}</li>
            <li>{t('js_crawlabilityStep1Bullet2')}</li>
            <li>{t('js_crawlabilityStep1Bullet3')}</li>
          </ul>
          <p>{t('js_crawlabilityStep1Description2')}</p>
          <div className={cls.codeblock}>
            {
              // eslint-disable-next-line react/jsx-no-comment-textnodes
              <code>
                // app/page.js
                <br />
                export default async function Page() {'{'}
                <br />
                &nbsp;const data = await fetch('https://api.example.com/data')
                <br />
                &nbsp;const json = await data.json()
                <br />
                &nbsp;return {'<div>{json.content}</div>'}
                <br />
                {'}'}
              </code>
            }
          </div>
          <p>{t('js_crawlabilityStep1Description3')}</p>
          <div className={cls.codeblock}>
            {
              // eslint-disable-next-line react/jsx-no-comment-textnodes
              <code>
                // pages/[id].js
                <br />
                export async function getStaticProps({'{ params }'}) {'{'}
                <br />
                &nbsp;const data = await fetchData(params.id)
                <br />
                &nbsp;return {'{ props: { data } }'}
                <br />
                {'}'}
              </code>
            }
          </div>
        </div>
        <div>
          <h4>
            {t('step')} 2 {t('js_crawlabilityStep2')}
          </h4>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('js_crawlabilityStep2Bullet1')}</li>
            <li>{t('js_crawlabilityStep2Bullet2')}</li>
            <li>{t('js_crawlabilityStep2Bullet3')}</li>
            <li>{t('js_crawlabilityStep2Bullet4')}</li>
          </ul>
        </div>
        <div>
          <h4>
            {t('step')} 3 {t('js_crawlabilityStep3')}
          </h4>
          <p>{t('js_crawlabilityStep3Description')}</p>
          <div className={cls.codeblock}>
            <code>
              {"<div id='app'>"}
              <br />
              &nbsp;{'<noscript>'}
              <br />
              {isEN ? (
                <>
                  &nbsp;&nbsp;{'<p>'}"This page requires JavaScript. Please
                  enable JavaScript to view the full content."
                  {'</p>'}
                  <br />
                </>
              ) : (
                <>
                  &nbsp;&nbsp;{'<p>'}
                  "Diese Seite benötigt JavaScript. Bitte aktivieren Sie
                  JavaScript, um den vollständigen Inhalt zu sehen."
                  {'</p>'}
                  <br />
                </>
              )}
              &nbsp;{'</noscript>'}
              <br />
              &nbsp;{'<!-- JavaScript wird hier rendern -->'}
              <br />
              {'</div>'}
            </code>
          </div>
          <p>{t('js_crawlabilityStep3Description2')}</p>
        </div>
        <div>
          <h4>
            {t('step')} 4 {t('js_crawlabilityStep4')}
          </h4>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('js_crawlabilityStep4Bullet1')}</li>
            <li>{t('js_crawlabilityStep4Bullet2')}</li>
            <li>{t('js_crawlabilityStep4Bullet3')}</li>
            <li>{t('js_crawlabilityStep4Bullet4')}</li>
          </ul>
        </div>
        <div>
          <h4>
            {t('step')} 5 {t('js_crawlabilityStep5')}
          </h4>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('js_crawlabilityStep5Bullet1')}</li>
            <li>{t('js_crawlabilityStep5Bullet2')}</li>
            <li>{t('js_crawlabilityStep5Bullet3')}</li>
            <li>{t('js_crawlabilityStep5Bullet4')}</li>
            <li>{t('js_crawlabilityStep5Bullet5')}</li>
          </ul>
        </div>
        <div>
          <h4>
            {t('bestPractices')}:{' '}
            <span>{t('js_crawlabilityBestPractices')}</span>
          </h4>
        </div>
      </div>
    );
  }

  if (ruleKey === 'speed_of_load') {
    return isTrial ? (
      <div className={cls.stepsWrapper}>
        <div>
          <h4>
            {t('step')} 1 {t('speed_of_loadStep1')}
          </h4>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('speed_of_loadStep1Bullet1')}</li>
            <li>{t('speed_of_loadStep1Bullet2')}</li>
          </ul>
          <div className={cls.codeblock}>
            <code>
              {
                '<img src="product.webp" alt="Product" loading="lazy" width="800" height="600"></img>'
              }
            </code>
          </div>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('speed_of_loadStep1Bullet4')}</li>
          </ul>
          <div className={cls.codeblock}>
            <code>
              {
                '<img srcset="small.webp 400w, medium.webp 800w, large.webp 1200w" \n     sizes="(max-width: 600px) 400px, 800px" src="medium.webp" alt="Product">'
              }
            </code>
          </div>
        </div>
        <div className={cls.trialOverlay}></div>
      </div>
    ) : (
      <div className={cls.stepsWrapper}>
        <div>
          <h4>
            {t('step')} 1 {t('speed_of_loadStep1')}
          </h4>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('speed_of_loadStep1Bullet1')}</li>
            <li>{t('speed_of_loadStep1Bullet2')}</li>
          </ul>
          <div className={cls.codeblock}>
            <code>
              {
                '<img src="product.webp" alt="Product" loading="lazy" width="800" height="600"></img>'
              }
            </code>
          </div>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('speed_of_loadStep1Bullet4')}</li>
          </ul>
          <div className={cls.codeblock}>
            <code>
              {
                '<img srcset="small.webp 400w, medium.webp 800w, large.webp 1200w" \n     sizes="(max-width: 600px) 400px, 800px" src="medium.webp" alt="Product">'
              }
            </code>
          </div>
        </div>
        <div>
          <h4>
            {t('step')} 2 {t('speed_of_loadStep2')}
          </h4>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('speed_of_loadStep2Bullet1')}</li>
          </ul>
          <div className={cls.codeblock}>
            <code>
              {isEN
                ? '// Dynamic import for code splitting '
                : '// Dynamischer Import für Code Splitting'}{' '}
              <br />
              const module = await import('./heavy-module.js');
            </code>
          </div>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('speed_of_loadStep2Bullet2')}</li>
          </ul>
          <div className={cls.codeblock}>
            <code>
              {
                '<link rel="preload" href="styles.css" as="style" onload="this.onload=null;this.rel=\'stylesheet\'">'
              }
            </code>
          </div>
        </div>
        <div>
          <h4>
            {t('step')} 3 {t('speed_of_loadStep3')}
          </h4>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('speed_of_loadStep3Bullet1')}</li>
            <li>{t('speed_of_loadStep3Bullet2')}</li>
            <li>{t('speed_of_loadStep3Bullet3')}</li>
            <li>{t('speed_of_loadStep3Bullet4')}</li>
          </ul>
        </div>
        <div>
          <h4>
            {t('step')} 4 {t('speed_of_loadStep4')}
          </h4>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('speed_of_loadStep4Bullet1')}</li>
            <li>{t('speed_of_loadStep4Bullet2')}</li>
          </ul>
          <div className={cls.codeblock}>
            <code>
              {
                '<link rel="preload" href="font.woff2" as="font" type="font/woff2" crossorigin>'
              }
              <br />
              {
                '<link rel="preload" href="hero.webp" as="image" fetchpriority="high">'
              }
            </code>
          </div>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('speed_of_loadStep4Bullet3')}</li>
            <li>{t('speed_of_loadStep4Bullet4')}</li>
          </ul>
        </div>
        <div>
          <h4>
            {t('step')} 5 {t('speed_of_loadStep5')}
          </h4>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('speed_of_loadStep5Bullet1')}</li>
            <li>{t('speed_of_loadStep5Bullet2')}</li>
            <li>{t('speed_of_loadStep5Bullet3')}</li>
            <li>{t('speed_of_loadStep5Bullet4')}</li>
            <li>{t('speed_of_loadStep5Bullet5')}</li>
          </ul>
        </div>
        <div>
          <h4>
            {t('bestPractices')}: <span>{t('speed_of_loadBestPractices')}</span>
          </h4>
        </div>
      </div>
    );
  }

  if (ruleKey === 'core_web_vitals') {
    return isTrial ? (
      <div className={cls.stepsWrapper}>
        <div>
          <h4>
            {t('step')} 1 {t('core_web_vitalsStep1')}
          </h4>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('core_web_vitalsStep1Bullet1')}</li>
            <li>{t('core_web_vitalsStep1Bullet2')}</li>
            <li>{t('core_web_vitalsStep1Bullet3')}</li>
          </ul>
          <div className={cls.codeblock}>
            <code>
              {
                '<link rel="preload" as="image" href="hero.webp" fetchpriority="high">'
              }
              <br />
              {'<img src="hero.webp" alt="Hero" fetchpriority="high">'}
            </code>
          </div>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('core_web_vitalsStep1Bullet4')}</li>
            <li>{t('core_web_vitalsStep1Bullet5')}</li>
          </ul>
        </div>
        <div className={cls.trialOverlay}></div>
      </div>
    ) : (
      <div className={cls.stepsWrapper}>
        <div>
          <h4>
            {t('step')} 1 {t('core_web_vitalsStep1')}
          </h4>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('core_web_vitalsStep1Bullet1')}</li>
            <li>{t('core_web_vitalsStep1Bullet2')}</li>
            <li>{t('core_web_vitalsStep1Bullet3')}</li>
          </ul>
          <div className={cls.codeblock}>
            <code>
              {
                '<link rel="preload" as="image" href="hero.webp" fetchpriority="high">'
              }
              <br />
              {'<img src="hero.webp" alt="Hero" fetchpriority="high">'}
            </code>
          </div>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('core_web_vitalsStep1Bullet4')}</li>
            <li>{t('core_web_vitalsStep1Bullet5')}</li>
          </ul>
        </div>
        <div>
          <h4>
            {t('step')} 2 {t('core_web_vitalsStep2')}
          </h4>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('core_web_vitalsStep2Bullet1')}</li>
          </ul>
          <div className={cls.codeblock}>
            <code>
              {'async function processLargeDataset(items) {'}
              <br />
              &nbsp;{'for (let i = 0; i < items.length; i++) {'}
              <br />
              &nbsp;&nbsp;{'    processItem(items[i]);'}
              <br />
              &nbsp;&nbsp;{'    if (i % 50 === 0) {'}
              <br />
              &nbsp;&nbsp;&nbsp;
              {'      await new Promise(resolve => setTimeout(resolve, 0));'}
              <br />
              &nbsp;&nbsp;{'    }'}
              <br />
              &nbsp;{'  }'}
              <br />
              {'}'}
            </code>
          </div>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('core_web_vitalsStep2Bullet2')}</li>
          </ul>
          <div className={cls.codeblock}>
            <code>
              const handleSearch = debounce((query) {'=>'} performSearch(query),
              300);
            </code>
          </div>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('core_web_vitalsStep2Bullet3')}</li>
            <li>{t('core_web_vitalsStep2Bullet4')}</li>
          </ul>
        </div>
        <div>
          <h4>
            {t('step')} 3 {t('core_web_vitalsStep3')}
          </h4>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('core_web_vitalsStep3Bullet1')}</li>
          </ul>
          <div className={cls.codeblock}>
            <code>
              {'<img src="product.jpg" alt="Product" width="800" height="600">'}
              <br />
              {'<'}!--{' '}
              {isEN
                ? 'Or use aspect-ratio for responsive'
                : 'Oder aspect-ratio für responsive'}{' '}
              --{'>'}
              <br />
              {
                '<img src="product.jpg" style="aspect-ratio: 16/9; width: 100%; height: auto;">'
              }
            </code>
          </div>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('core_web_vitalsStep3Bullet2')}</li>
          </ul>
          <div className={cls.codeblock}>
            <code>
              .ad-slot {'{ min-height: 250px; }'}
              <br />
              .video-container {'{ aspect-ratio: 16/9; }'}
            </code>
          </div>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('core_web_vitalsStep3Bullet3')}</li>
            <li>{t('core_web_vitalsStep3Bullet4')}</li>
          </ul>
          <div className={cls.codeblock}>
            <code>
              {isEN
                ? '/* Good - no layout shift */ '
                : '/* Gut - keine Layout-Verschiebung */ '}
              <br />
              @keyframes slideIn {'{'}
              <br />
              &nbsp;&nbsp;from {'{ transform: translateY(-100px); }'}
              <br />
              &nbsp;&nbsp;to {'{ transform: translateY(0); }'}
              <br />
              {'}'}
            </code>
          </div>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('core_web_vitalsStep3Bullet5')}</li>
          </ul>
        </div>
        <div>
          <h4>
            {t('step')} 4 {t('core_web_vitalsStep4')}
          </h4>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('core_web_vitalsStep4Bullet1')}</li>
            <li>{t('core_web_vitalsStep4Bullet2')}</li>
            <li>{t('core_web_vitalsStep4Bullet3')}</li>
            <li>{t('core_web_vitalsStep4Bullet4')}</li>
            <li>{t('core_web_vitalsStep4Bullet5')}</li>
          </ul>
        </div>
        <div>
          <h4>
            {t('step')} 5 {t('core_web_vitalsStep5')}
          </h4>
          <ul style={{ listStyle: `url(${ICONS.listStar})` }}>
            <li>{t('core_web_vitalsStep5Bullet1')}</li>
            <li>{t('core_web_vitalsStep5Bullet2')}</li>
            <li>{t('core_web_vitalsStep5Bullet3')}</li>
            <li>{t('core_web_vitalsStep5Bullet4')}</li>
            <li>{t('core_web_vitalsStep5Bullet5')}</li>
            <li>{t('core_web_vitalsStep5Bullet6')}</li>
            <li>{t('core_web_vitalsStep5Bullet7')}</li>
            <li>{t('core_web_vitalsStep5Bullet8')}</li>
            <li>{t('core_web_vitalsStep5Bullet9')}</li>
          </ul>
        </div>
        <div>
          <h4>
            {t('bestPractices')}:{' '}
            <span>{t('core_web_vitalsBestPractices')}</span>
          </h4>
        </div>
      </div>
    );
  }

  return null;
};
